module.exports = __webpack_public_path__ + "img/d3.7c850108.jpg";